(() => {
  const initializedRoots = new WeakSet();

  function initialize(root) {
    if (!(root instanceof HTMLElement) || initializedRoots.has(root)) return;
    initializedRoots.add(root);

    let dialog;
    let opener;

    function closeDialog() {
      if (dialog?.open) dialog.close();
    }

    function getDialog() {
      if (dialog) return dialog;

      dialog = document.createElement('dialog');
      dialog.className = 'ms-private-label-gallery';
      dialog.setAttribute('aria-label', 'Enlarged private-label reference image');
      dialog.innerHTML = '<button type="button" data-private-gallery-close aria-label="Close enlarged image">×</button><img alt=""><p></p>';
      root.append(dialog);

      dialog.addEventListener('close', () => {
        const previousOpener = opener;
        opener = null;
        if (previousOpener?.isConnected) previousOpener.focus();
      });
      dialog.querySelector('[data-private-gallery-close]')?.addEventListener('click', closeDialog);
      return dialog;
    }

    root.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('main.ms-private-label-main [data-private-gallery]');
      if (trigger) {
        const image = trigger.querySelector('img');
        const source = image?.currentSrc || image?.src;
        if (!source) return;

        const caption = trigger.dataset.caption || image.alt || '';
        const modal = getDialog();
        const modalImage = modal.querySelector('img');
        opener = trigger;
        modalImage.src = source;
        modalImage.alt = caption;
        modal.querySelector('p').textContent = caption;
        modal.showModal();
        return;
      }

      if (event.target.closest('[data-private-gallery-close]')) closeDialog();
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (opener && event.target instanceof Element && event.target.contains(opener)) closeDialog();
    });
  }

  function initializePage() {
    initialize(document.querySelector('main.ms-private-label-main'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePage, { once: true });
  } else {
    initializePage();
  }
  document.addEventListener('shopify:section:load', initializePage);
})();
